import { computed, Directive, ElementRef, inject, input, InputSignal, OnInit, Renderer2, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { KeycloakService } from '@ogs/ngx-keycloak';
import { Permission } from '@shared/types/permission.types';
import { Observable } from 'rxjs';

@Directive({
  selector: '[appRestricted]',
  standalone: true
})
export class RestrictedDirective implements OnInit {
  private _elementRef: ElementRef = inject(ElementRef);

  private _keycloakService: KeycloakService = inject(KeycloakService);

  private _renderer: Renderer2 = inject(Renderer2);

  public permissions: InputSignal<Permission[] | undefined> = input();

  public restrictionStrategy: InputSignal<"hide" | "disable"> = input<"hide" | "disable">("disable");

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  private _isPermitted: Signal<boolean> = computed((): boolean =>
    this.permissions()?.every((permission: Permission): boolean => this._keycloakService.hasAccessTokenResourceAccess(permission.resource, permission.role)) ?? true);

  private _isPermitted$: Observable<boolean> = toObservable(this._isPermitted);

  private _nativeElement: unknown;


  constructor () {
    this._nativeElement = this._elementRef.nativeElement;
  }

  public ngOnInit (): void {
    this._isPermitted$.subscribe({
      next: (isPermitted: boolean) => {
        this.setDisableState(!isPermitted);
      }
    });
  }

  private setDisableState (isDisabled: boolean): void {
    if (this._nativeElement) {
      this._renderer.setProperty(this._nativeElement, "disabled", isDisabled);

      if (this.restrictionStrategy() === "hide" && isDisabled)
        this._renderer.setStyle(this._nativeElement, 'visibility', 'hidden');
    }
  }
}
